import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const CdbLog = {
	name: NAME,
	router,
	apiProvider,
};
